/* Qalbeen · HOVER : collection et recherche.
   Filtres, tri et « Voir plus » sans recharger la page (Section Rendering API de Shopify), adresse mise à jour,
   retour arrière géré. Sans JavaScript, tout marche quand même (formulaire GET et liens).
   Rappel « livraison offerte » mis à jour quand le panier change. */
(function () {
  if (window.HoverCollection) return;
  var D = document;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, c) { return (c || D).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || D).querySelectorAll(s)); };
  var ctrl = null;

  function root() { return $('[data-hvc]'); }
  function propre(u) {
    var url = new URL(u, location.href);
    url.searchParams.delete('section_id');
    return url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash;
  }
  function nettoyer(el) {
    $$('a[href*="section_id="]', el).forEach(function (a) { a.setAttribute('href', propre(a.getAttribute('href'))); });
  }
  function charger(u) {
    var r = root(); if (!r) return Promise.reject();
    var url = new URL(u, location.href);
    url.searchParams.set('section_id', r.getAttribute('data-section'));
    if (ctrl) ctrl.abort();
    ctrl = 'AbortController' in window ? new AbortController() : null;
    return fetch(url.toString(), { signal: ctrl ? ctrl.signal : undefined, credentials: 'same-origin' })
      .then(function (res) { if (!res.ok) throw new Error(res.status); return res.text(); })
      .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
  }
  function initUI(c) {
    /* la puce de la collection affichée reste visible dans la rangée qui défile */
    $$('[data-hvc-chips]', c).forEach(function (n) {
      var a = $('[aria-current]', n); if (!a) return;
      var x = a.offsetLeft - (n.clientWidth - a.offsetWidth) / 2;
      if (x > 0) n.scrollLeft = x;
    });
  }

  /* remplace les résultats (et les compteurs du tiroir) par ceux de l'adresse u */
  function appliquer(u, opts) {
    opts = opts || {};
    var r = root(); if (!r) { location.href = u; return; }
    var res = $('[data-hvc-res]', r);
    if (res) res.classList.add('is-loading');
    var focusId = D.activeElement && D.activeElement.id;
    return charger(u).then(function (doc) {
      ['[data-hvc-res]', '[data-hvc-tools]', '[data-hvc-fbody]'].forEach(function (s) {
        var neuf = $(s, doc), vieux = $(s, r);
        if (neuf && vieux) { vieux.innerHTML = neuf.innerHTML; nettoyer(vieux); }
      });
      var ab = $('[data-hvc-apply]', doc), aa = $('[data-hvc-apply]', r);
      if (ab && aa) aa.innerHTML = ab.innerHTML;
      var ca = $('[data-hvc-tools] [data-hv-open]', r);
      var dr = $('.hvc-dr.on', r);
      if (ca && dr) ca.setAttribute('aria-expanded', 'true');
      if (focusId) { var f = D.getElementById(focusId); if (f && f.focus) f.focus({ preventScroll: true }); }
      if (!opts.pop) history.pushState({ hvc: 1 }, '', propre(u));
      if (opts.haut) {
        var bar = $('.hvc-bar', r) || r;
        var y = bar.getBoundingClientRect().top + scrollY - (parseInt(getComputedStyle(D.documentElement).getPropertyValue('--hv-hd-h'), 10) || 0);
        if (scrollY > y + 2) window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
      }
      premiereLivraison(r);
      if (window.HoverQalbeen) HoverQalbeen.init(r);
    }).catch(function (e) { if (e && e.name === 'AbortError') return; location.href = u; })
      .then(function () { var x = $('[data-hvc-res]', root()); if (x) x.classList.remove('is-loading'); });
  }

  function adresseFormulaire(form) {
    var p = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (v !== '') p.append(k, v); });
    var base = form.getAttribute('action') || location.pathname;
    var s = p.toString();
    return base + (s ? '?' + s : '');
  }

  /* tri */
  D.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-hvc-sort]')) {
      var f = D.getElementById(t.getAttribute('form'));
      if (f) appliquer(adresseFormulaire(f), { haut: true });
      return;
    }
    /* filtres : la grille se met à jour derrière le tiroir à chaque case cochée */
    var form = t.closest && t.closest('[data-hvc-form]');
    if (form && t.type === 'checkbox') appliquer(adresseFormulaire(form));
  });
  D.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-hvc-form]');
    if (!form) return;
    e.preventDefault();
    if (window.HoverQalbeen) HoverQalbeen.fermer();
    appliquer(adresseFormulaire(form), { haut: true });
  });
  /* liens : retirer un filtre, tout effacer */
  D.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-hvc-link]');
    if (a && !e.metaKey && !e.ctrlKey) {
      e.preventDefault();
      var dansTiroir = a.closest('.hvc-dr');
      appliquer(a.getAttribute('href'), { haut: !dansTiroir });
      return;
    }
    /* Voir plus : ajoute la page suivante sous la grille */
    var n = e.target.closest && e.target.closest('a[data-hvc-next]');
    if (!n || e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    if (n.classList.contains('is-loading')) return;
    n.classList.add('is-loading');
    var sp = $('.loading__spinner', n); if (sp) sp.classList.remove('hidden');
    var r = root();
    charger(n.getAttribute('href')).then(function (doc) {
      var g = $('[data-hvc-grid]', r), gn = $('[data-hvc-grid]', doc);
      if (g && gn) $$(':scope > .hv-card', gn).forEach(function (c) { c.classList.add('hvc-new'); g.appendChild(c); });
      var h = $('[data-hvc-hits]', r), hn = $('[data-hvc-hits]', doc);
      if (hn) { if (h) $$(':scope > a', hn).forEach(function (a) { h.appendChild(a); }); else { var m0 = $('[data-hvc-more]', r); if (m0) m0.parentNode.insertBefore(hn, m0); } }
      var m = $('[data-hvc-more]', r), mn = $('[data-hvc-more]', doc);
      if (m && mn) { m.innerHTML = mn.innerHTML; nettoyer(m); }
      if (window.HoverQalbeen) HoverQalbeen.init(r);
    }).catch(function (err) { if (err && err.name === 'AbortError') return; location.href = n.getAttribute('href'); });
  });
  window.addEventListener('popstate', function () { if (root()) appliquer(location.href, { pop: true }); });

  /* rappel livraison offerte : seuil (devise de la boutique) converti au taux Shopify Markets, comme le panier Kaching */
  function ecrireLivraison(b, tot, n, cur) {
    var rate = +(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
    var seuil = Math.round(+b.getAttribute('data-seuil') * rate), reste = seuil - tot;
    var modele = (b.getAttribute('data-fmt') || '').match(/^(.*?)1(\D?)234(\D)56(.*)$/);
    var fmt = function (c) {
      if (modele) { /* même écriture que le filtre money de Shopify (ex. « 1 234,56 € » ou « $1,234.56 ») */
        var u = String(Math.floor(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, modele[2]), d = c % 100;
        return modele[1] + u + (d ? modele[3] + (d < 10 ? '0' : '') + d : '') + modele[4];
      }
      try { return new Intl.NumberFormat(D.documentElement.lang || 'en', { style: 'currency', currency: cur, minimumFractionDigits: c % 100 ? 2 : 0 }).format(c / 100); } catch (x) { return (c / 100).toFixed(2); }
    };
    var t;
    if (!n) t = b.getAttribute('data-t0').replace('[montant]', fmt(Math.round(seuil / 100) * 100));
    else if (reste > 0) t = b.getAttribute('data-t1').replace('[montant]', fmt(reste));
    else t = b.getAttribute('data-t2');
    var el = $('[data-hvc-ship-t]', b); if (el) el.textContent = t;
    var i = $('.hvc-ship__bar i', b); if (i) i.style.width = Math.min(100, Math.round(tot * 100 / seuil)) + '%';
    b.classList.toggle('is-ok', n > 0 && reste <= 0);
    b.classList.remove('is-wait');
  }
  function majLivraison() {
    var b = $('[data-hvc-ship]'); if (!b) return;
    fetch((window.routes && routes.cart_url ? routes.cart_url : '/cart') + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { ecrireLivraison(b, cart.total_price || 0, cart.item_count, cart.currency || b.getAttribute('data-cur')); })
      .catch(function () {});
  }
  function premiereLivraison(c) {
    $$('[data-hvc-ship].is-wait', c).forEach(function (b) { ecrireLivraison(b, +b.getAttribute('data-total') || 0, +b.getAttribute('data-n') || 0, b.getAttribute('data-cur')); });
  }
  var tLiv = null;
  function bientot() { clearTimeout(tLiv); tLiv = setTimeout(majLivraison, 600); }
  if (window.subscribe && window.PUB_SUB_EVENTS) subscribe(PUB_SUB_EVENTS.cartUpdate, bientot);
  /* le panier Kaching ne passe pas par l'événement de Dawn : on repère ses appels au panier (ajout, modification) */
  if ('PerformanceObserver' in window && $('[data-hvc-ship]')) {
    try {
      new PerformanceObserver(function (l) {
        if (l.getEntries().some(function (e) { return /\/cart\/(add|change|update|clear)/.test(e.name); })) bientot();
      }).observe({ type: 'resource', buffered: false });
    } catch (x) {}
  }
  D.addEventListener('visibilitychange', function () { if (!D.hidden) majLivraison(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) majLivraison(); });

  window.HoverCollection = { appliquer: appliquer, majLivraison: majLivraison };
  initUI(D); premiereLivraison(D);
  D.addEventListener('shopify:section:load', function (e) { initUI(e.target); premiereLivraison(e.target); });
})();
